import { useMemo } from 'react'

import { GroupedStoryPanels } from '@/components/panels/StoryPanels.tsx'
import { useQueryStories } from '@/requests/queries/useQueryProject.ts'

type Props = {
  isShowDone: boolean
  isShowRelevant: boolean
  isShowUnscheduled: boolean
}
export const BlockedStoriesView = ({ isShowDone, isShowRelevant, isShowUnscheduled }: Props) => {
  return (
    <GroupedStoryPanels
      filter={filterBlockedStories}
      isShowDone={isShowDone}
      isShowRelevant={isShowRelevant}
      isShowUnscheduled={isShowUnscheduled}
    />
  )
}

export const filterBlockedStories = (stories: Story[]) =>
  stories.filter((story) => story.blockers.some((blocker) => !blocker.resolved))

export const useBlockedStoriesSummary = () => {
  const { stories: relevant } = useQueryStories('relevant')
  const { stories: unscheduled } = useQueryStories('unscheduled')

  const blockedStoryCount = useMemo(
    () => filterBlockedStories([...relevant, ...unscheduled]).length,
    [relevant, unscheduled],
  )

  return { blockedStoryCount }
}
